











































import { mixins, Component, Prop } from 'nuxt-property-decorator';

import OnboardingLayout from '@/components/partials/onboarding-v3_1/OnboardingLayout.vue';
import ReferralPrizeMixin from '@/components/partials/referral/ReferralInvite/referralPrizeMixin';
import type { Step } from '@/components/partials/onboarding-v3_1/types';
import type { UserReferrerQuery } from '~/types/graphql';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import { INDEX_PAGE, REFERRAL_PRE_ONBOARDING_PAGE, SIGN_UP_MODAL } from '~/constants';
import BravadoPillV2 from '~/components/common/BravadoPillV2/BravadoPillV2.vue';
import Avatar from '~/components/common/Avatar/Avatar.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

@Component({
  components: {
    OnboardingLayout,
    BravadoButtonV3,
    BravadoText,
    BravadoPillV2,
    Avatar,
  },
})
export default class ReferralOnboarding extends mixins(ReferralPrizeMixin) {
  @Prop() userReferrer!: UserReferrerQuery['userReferrer'];

  currentStep: Step = {
    slug: 'onboarding-referral',
    title: 'Onboarding Referral',
    fieldName: 'advance',
    component: 'BravadoText',
    submitOnChange: true,
  };

  handleSubmit() {
    return this.$utils.redirectWithQuery({
      ...REFERRAL_PRE_ONBOARDING_PAGE,
      query: { dynamic_modal: SIGN_UP_MODAL, refferer: '/' },
    });
  }

  created() {
    if (this.$auth.loggedIn) {
      this.$utils.redirectWithQuery(INDEX_PAGE);
    }
  }

  get userReferrerName() {
    return `${this.userReferrer?.firstname || ''} ${this.userReferrer?.lastname || ''}`;
  }

  get userReferrerAvatar() {
    return this.userReferrer?.avatarUrl;
  }
}
